/**
 * Static, clearly fictional demo content for the public sales demos
 * (/athlete-profile-demo and /athlete-business-hub-demo). This is NOT an
 * athlete record: it never touches the database, search, exports or analytics.
 */
import hero from "@/assets/demo-avery-hero.jpg";
import tennis from "@/assets/athlete-tennis.jpg";
import basketball from "@/assets/athlete-basketball.jpg";
import surf from "@/assets/athlete-surf.jpg";

export const DEMO_ATHLETE_ID = "demo-avery-morgan";
export const DEMO_PROFILE_PATH = "/athlete-profile-demo";
export const DEMO_HUB_PATH = "/athlete-business-hub-demo";

export const demoAthlete = {
  id: DEMO_ATHLETE_ID,
  slug: "athlete-profile-demo",
  name: "Avery Morgan",
  firstName: "Avery",
  sport: "Soccer",
  position: "Midfielder",
  location: "Philadelphia, PA",
  level: "Professional",
  jersey: "8",
  image: hero,
  tagline: "Midfielder. Builder. The player who makes everyone around her better.",
  statement: "Make the play. Make the space.",
  story: [
    "Avery grew up on the public fields of South Philly, the youngest on every team she joined and the one who always wanted the ball back. She learned early that the best players don't just score — they make the game easier for everyone else.",
    "Now a professional midfielder, she is known for the pass nobody else sees and the work nobody else wants to do. Coaches call her the connector; teammates call her the reason they look good.",
    "Off the field she runs free Saturday clinics for girls who have never played organized sport, and she is building a content series about what it actually takes to make it — the setbacks included.",
  ],
  cards: [
    { title: "What she plays for", body: "Access. Every girl in her city should have a field, a ball and a coach who believes in her." },
    { title: "Her edge", body: "Vision. She reads the game two passes ahead and turns pressure into space." },
    { title: "Off the field", body: "Saturday clinics, coffee-shop journaling and a very competitive family Scrabble league." },
    { title: "Content lane", body: "Honest training diaries, game-day breakdowns and the business of being a pro athlete." },
  ],
  updates: [
    { date: "Oct 10", title: "Back in the starting XI", body: "Ninety minutes, one assist and a clean sheet. Thank you for riding with me through the injury months." },
    { date: "Oct 3", title: "Clinic #12 is full", body: "Forty girls signed up this Saturday — our biggest group yet. Volunteers, I owe you." },
    { date: "Sep 26", title: "Film room: how I find space", body: "A short breakdown of the scan-before-receive habit that changed my game." },
  ],
  cause: {
    name: "Open Fields Philly (sample cause)",
    blurb: "Fictional demo cause: free weekend soccer clinics and gear for girls across Philadelphia.",
  },
  collection: [
    { name: "Make the Space Tee", price: "$30", note: "Sample item" },
    { name: "Midfield Crew Hoodie", price: "$58", note: "Sample item" },
    { name: "Clinic Day Cap", price: "$26", note: "Sample item" },
  ],
  partnershipInterests: "Brand partnerships, youth clinics and appearances, media interviews, content collaborations.",
};

export const demoRelated = [
  { name: "Jordan Ellis", sport: "Tennis", tagline: "Sample athlete card", image: tennis },
  { name: "Simone Adeyemi", sport: "Basketball", tagline: "Sample athlete card", image: basketball },
  { name: "Kaia Brooks", sport: "Surf", tagline: "Sample athlete card", image: surf },
];
